
/**
 * Events
 */
export default class Events {

    public static readonly ANIMATION_COMPLETE: string = "animationComplete";
    public static readonly ANIMATION_READY: string = "animationReady";

    public static readonly ANIMATE_IN: string = "animate-in";
    public static readonly ANIMATE_IN_START: string = "animate-in-start";
    public static readonly ANIMATE_OUT: string = "animate-out";

    public static readonly BACKGROUND_PAUSE: string = "background:pause";
    public static readonly BACKGROUND_PLAY: string = "background:play";
    public static readonly BLUR: string = "blur";

    public static readonly CLICK: string = "click";
    public static readonly CLOSE: string = "close";
    public static readonly COMPLETE: string = "complete";
    public static readonly CONTROL: string = "control";

    public static readonly FOCUS: string = "focus";

    public static readonly MOBILE: string = "mobile";
    public static readonly MOUSEMOVE: string = "mousemove";

    public static readonly PLAY: string = "play";
    public static readonly PROGRESS: string = "progress";

    public static readonly RESIZE: string = "resize";

}
